import gql from "graphql-tag";
import { useQuery } from "@apollo/react-hooks";

const QUERY = gql`
  query users($role: String) {
    users(role: $role) {
      id
      name
      email
      role
    }
  }
`;

const useUsers = () => {
  const { loading, error, data, refetch } = useQuery(QUERY, {
    fetchPolicy: "no-cache",
    notifyOnNetworkStatusChange: true,
  });

  return { loading, error, refetch, data: data?.users };
};

export default useUsers;
